var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DxCheckBox',{ref:'grid-cb-' + _vm.refKey,attrs:{"on-value-changed":_vm.onSelectionChanged,"element-attr":_vm.checkBoxAttributes,"value":_vm.value,"readOnly":_vm.readOnly,"disabled":_vm.disabled}})}
var staticRenderFns = []

export { render, staticRenderFns }